import loadingFlag from "assets/images/GASL-FlagLoading.gif";

const LoadingFlag = ({ ...props }) => (
  <img {...props} src={loadingFlag} />
);

export default LoadingFlag;
